const ACCESS_TOKEN_KEY = 'accessToken';
const USER_KEY = 'user';

export const getStoredAccessToken = (): string | null =>
  sessionStorage.getItem(ACCESS_TOKEN_KEY);

export const setStoredAccessToken = (token: string) => {
  sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
};

export const clearStoredAccessToken = () => {
  sessionStorage.removeItem(ACCESS_TOKEN_KEY);
};

export const getStoredUser = (): string | null =>
  localStorage.getItem(USER_KEY);

export const setStoredUser = (user: string) => {
  localStorage.setItem(USER_KEY, user);
};

export const clearStoredUser = () => {
  localStorage.removeItem(USER_KEY);
};
